module.exports = __webpack_public_path__ + "img/newPaintingPav12m.6e958018.png";